import React from 'react'
import Label from '../../../Form/Label'

const CustomerTestimonial = ({
    formData,
    setFormData,
    sampleGuide,
 
}
) => {
  return (
    <main className="flex w-full justify-between gap-6">
      <div className="bg-white h-fit  flex flex-col gap-3 rounded-[10px] p-[30px] w-[42%]">
        <div className="text-customGreen  text-[17px] mb-4 font-semibold">
          Section Layout
        </div>
        <img
          src={sampleGuide?.customerTestimonial}
          className="w-full"
          alt="Header and Hero Preview"
        />
      </div>
      <div className="bg-white overflow-x-auto min-h-72 rounded-[10px] p-[30px] flex-1">
        <div className="flex items-center justify-between flex-1 mb-8">
          <div className="text-customGreen text-[17px] font-semibold  ">
          Customer Testimonial Section
          </div>

          <div className="flex ">
            <label className="inline-flex mb-5 cursor-pointer">
            
            <input
                      type="checkbox"
                      checked={formData.customerTestimonial.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          customerTestimonial: {
                            ...formData.customerTestimonial,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                    
          </div>
        </div>
            <div className="flex flex-col gap-3">
              {/* <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.customerTestimonial.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          customerTestimonial: {
                            ...formData.customerTestimonial,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div> */}
              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter section title"
                    value={formData.customerTestimonial.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        customerTestimonial: {
                          ...formData.customerTestimonial,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              {["customer1", "customer2", "customer3"].map(
                (customer, index) => (
                  <div key={customer}>
                    <div className="flex justify-between gap-2">
                      <Label label={`Customer ${index + 1}`} />
                      <div className="flex items-center justify-center w-[75%]">
                        <input
                          type="text"
                          placeholder={`Enter customer ${index + 1} name`}
                          value={formData.customerTestimonial[customer].name}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              customerTestimonial: {
                                ...formData.customerTestimonial,
                                [customer]: {
                                  ...formData.customerTestimonial[customer],
                                  name: e.target.value,
                                },
                              },
                            })
                          }
                          maxLength={15}
                          className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                        />
                      </div>
                    </div>
                    <div className="flex justify-between gap-2 mt-4">
                      <Label label={`Customer Testimonial ${index + 1}`} />
                      <div className="flex items-center justify-center w-[75%]">
                        <textarea
                          placeholder={`Enter Customer Testimonial ${
                            index + 1
                          }`}
                          value={
                            formData.customerTestimonial[customer].feedback
                          }
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              customerTestimonial: {
                                ...formData.customerTestimonial,
                                [customer]: {
                                  ...formData.customerTestimonial[customer],
                                  feedback: e.target.value,
                                },
                              },
                            })
                          }
                          maxLength={120}
                          className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                        />
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
      
    </main>
  )
}

export default CustomerTestimonial
